<template>
<b-container :class="['plan-grid', { embedded: this.isEmbed, 'screen-lg': this.onTabletUp }]" v-if="plan">
  <div class="day-row" :class="{ 'nav-visible': this.isOpen }">
    <div class="day-col" v-for="(day, i) in plan.planDays" :key="i" :class="{ selected: selectedDaySlot }">
      <div class="day">
        <h3
          class="today"
          v-if="
            (() => {
              if (formatUTCDate(day) === today) {
                scrollToToday();
                return true;
              }
            })()
          "
        >
          <strong> {{ day.header }} </strong>
        </h3>
        <h3 class="title-day" v-else>
          <small> {{ day.header }} </small>
        </h3>
        <div class="calories">
          <h3>{{ dailyCalories(day) }} </h3>
          <h3 class="title-calories">{{ $t('lblCalories') }}</h3>
        </div>
      </div>
      <MealWidget :day="day" :plan="plan" :mealTime="day.Breakfast" :mealTimeSlot="'Breakfast'" :onTabletUp="onTabletUp" />
      <MealWidget :day="day" :plan="plan" :mealTime="day.Lunch" :mealTimeSlot="'Lunch'" :onTabletUp="onTabletUp" />
      <MealWidget :day="day" :plan="plan" :mealTime="day.Dinner" :mealTimeSlot="'Dinner'" :onTabletUp="onTabletUp" />
    </div>
  </div>
</b-container>
</template>

<script>
import store from '@state/store';
import environment from '@src/environment';
import { kitchenDrawerComputed, planComputed, planMethods } from '@state/helpers';
import MealWidget from '../MealWidget/MealWidget';
import utils from '@src/utils/utils';

export default {
  components: {
    MealWidget,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    planGetter: {
      type: Object,
      required: true,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      today: new Date().toLocaleDateString(),
      doneInitialScroll: false,
    };
  },
  computed: {
    ...kitchenDrawerComputed,
    ...planComputed,
    plan() {
      return this.planGetter || {};
    },
  },
  mounted() {},
  methods: {
    ...planMethods,
    dailyCalories(day) {
      const macros = day.aggregatedNutritionDigest.macroNutritionDigest;
      return macros && macros.calories ? macros.calories.value : 0;
    },
    formatUTCDate(day) {
      const date = new Date(day.dateString);
      return date.getUTCMonth() + 1 + '/' + date.getUTCDate() + '/' + date.getUTCFullYear();
    },
    scrollToToday() {
      if (this.$el && !this.doneInitialScroll) {
        const element = this.$el.getElementsByClassName('today')[0];
        if (element) {
          const container = this.$el.parentElement.parentElement;
          container.scrollTo({ left: element.offsetLeft - 100, behavior: 'smooth' });
          this.doneInitialScroll = true;
        }
      }
    },
  },
  watch: {
    gridVerticalPosition() {
      this.$refs.mealtimeIcons.style.top = `-${this.gridVerticalPosition}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.plan-grid {
  background-color: $color-body-bg;
  padding: 0 2rem 2rem 0;

  .day-row {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 10rem;
    padding-left: 4rem;

    // iPhone 6 up
    @include media('md', null) {
      padding-bottom: 12rem;
    }

    &.nav-visible {
      padding-bottom: 34rem;

      // iPhone 6 up
      @include media('md', null) {
        padding-bottom: 38rem;
      }
    }

    &::-webkit-scrollbar {
      background: transparent;
      width: 0;
    }

    .day-col {
      &:nth-child(even) {
        background-color: rgba($color-secondary, 0.2);
        border-bottom-left-radius: $base-border-radius;
        border-bottom-right-radius: $base-border-radius;
        padding: 1rem 0.8rem 0.6rem;

        &.selected {
          background-color: rgba($color-secondary, 0.2);
        }
      }

      padding: 1rem 0.8rem 0;

      .day {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 9rem;
        justify-content: center;
        width: 180px;

        .title-day {
          margin-bottom: 1.5rem;
        }

        .today {
          font-size: 1.6rem;
          font-weight: 400;
          margin-bottom: 1.5rem;
        }

        .calories {
          margin-bottom: 1rem;
          text-align: center;

          h3 {
            font-weight: 600;
            line-height: 1;
          }

          .title-calories {
            color: $color-plan-day-calories-title;
            font-size: 1.4rem;
          }

          h1,
          h4 {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  &.embedded {
    padding-top: 2rem;

    .day-row {
      margin-top: 4rem;
    }
  }

  &.screen-lg {
    padding: 0 2rem 2rem 0;

    .day-row {
      margin-top: 0;
    }
  }
}
</style>
